// removed by extract-text-webpack-plugin
module.exports = {"_root":"styles___root___3Qrjx","close-area":"styles__close-area___2MlBz","_menu-wrap":"styles___menu-wrap___1yAKD","_row":"styles___row___2VRNL","_menu":"styles___menu___T0j7P","none":"styles__none___1-Eu1","_3dot":"styles___3dot___dKBC1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PopupMenu/styles.scss
// module id = 7614
// module chunks = 0